import Vue from 'vue'
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import moment from 'moment'
import i18n from '@/libs/i18n'
import {
  setLocale, formatDate, formatDateTime, formatNumber,
} from '@/libs/i18n/locale'
import fileSizeFormatter from '@/libs/fileSizeFormatter'
import router from './router'
import store from './store'
import App from './App.vue'
// Global Components
import './global-components'

// 3rd party plugins
import '@axios'
import '@/libs/acl'
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/sweet-alerts'
import '@/libs/vue-select'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)

// Custom Plugins
Vue.use(fileSizeFormatter)

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')
require('@core/scss/vue/libs/vue-select.scss')
/* Custom Filters */
Vue.filter('toCurrency', value => formatNumber(value, 2))
Vue.filter('toNumber', value => formatNumber(value, 0))
Vue.filter('formatDate', formatDate)
Vue.filter('formatDateTime', formatDateTime)
Vue.prototype.moment = moment
Vue.config.productionTip = false
setLocale(i18n.locale)
new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')
